import { type Pathnames } from "next-intl/navigation";
import languages from "../language.json";

export const locales = languages.map((lang) => lang.code);
export const defaultLocale = "en";

export const pathnames = {
	"/": "/",
} as Pathnames<typeof locales>;

export const localePrefix = "as-needed"; // 删除默认语言路径前缀
export type AppPathnames = keyof typeof pathnames;
